var _defs, _clipPath, _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFig6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M35.6 4.7l-5.9 14.9-2.3-12.7c-.3-1.4-1.4-2.2-2.6-2.2h-9.6l-.2.6c2 .4 4.2 1.1 5.6 1.9.8.4 1.1.8 1.4 1.9l4.5 17.4h5.9l9.2-21.9-6 .1zm8.4 0l-4.7 21.9H45l4.7-21.9H44zm32.5 5.9l1.7 8.2h-4.7l3-8.2zm-.9-5.9c-1.1 0-2 .6-2.4 1.6l-8.5 20.3h5.9l1.2-3.3h7.3l.7 3.3H85L80.4 4.7h-4.8zm-24.4 6.8c0 3.1 2.8 4.9 5 5.9 2.2 1.1 2.9 1.8 2.9 2.7 0 1.5-1.7 2.1-3.4 2.2-2.8 0-4.5-.8-5.8-1.4l-1 4.8c1.3.6 3.7 1.1 6.3 1.2 5.9 0 9.8-2.9 9.8-7.5 0-5.8-8-6.1-7.9-8.7 0-.8.8-1.6 2.4-1.8.8-.1 3.1-.2 5.6 1l1-4.7c-1.4-.5-3.1-1-5.3-1-5.6.1-9.6 3.1-9.6 7.3"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 14.998,
    y1: 15.599,
    x2: 85.003,
    y2: 15.599
  }, /*#__PURE__*/React.createElement("shrefp", {
    offset: 0,
    shrefpColor: "#241f5d"
  }), /*#__PURE__*/React.createElement("shrefp", {
    offset: 1,
    shrefpColor: "#034ea1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.3h70v22.6H15z",
    clipPath: "url(#B)",
    fill: "url(#C)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFig6);
export default __webpack_public_path__ + "static/media/fig6.6cf668c9ae2fed65b938a95dd91c48ee.svg";
export { ForwardRef as ReactComponent };